import { FC, useContext } from 'react'
import { NotificationTrayOwnProps } from 'components/features/pfm/NotificationTray/NotificationTray'
import { NotificationTrayRenderLevel } from 'interfaces/component'
import { NotificationTrayContext } from 'components/features/pfm/NotificationTray/NotificationTrayContextProvider'
import NotificationTrayContainer from 'components/features/pfm/NotificationTray/NotificationTrayContainer'

type NotificationTrayWrapperProps =
  & NotificationTrayOwnProps
  & {
    renderLevel: NotificationTrayRenderLevel
  }

export const NotificationTrayWrapper: FC<NotificationTrayWrapperProps> = (props) => {
  const { renderLevel } = props
  const { notificationTrayRenderLevel } = useContext(NotificationTrayContext)

  if (renderLevel !== notificationTrayRenderLevel) {
    return null
  }

  return (
    <NotificationTrayContainer { ...props } />
  )
}
